export default __webpack_public_path__ + "static/media/20s_block_rotate.8592c333.mp3";